var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        attrs: { content: `${_vm.normativeGroup?.name}:`, "has-line": "" }
      }),
      _c("validation-provider", {
        attrs: { name: "groups", rules: "checks" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function({ errors }) {
              return [
                _c("options-panel", {
                  staticClass: "mx-3",
                  attrs: {
                    data: { options: _vm.normativeGroup?.options || [] },
                    "has-container-panel": false,
                    "is-read-only": _vm.isReadOnly,
                    "is-vertical": "",
                    "option-col": "col-4 py-3",
                    "show-header": false
                  },
                  model: {
                    value: _vm.normativeGroup.options,
                    callback: function($$v) {
                      _vm.$set(_vm.normativeGroup, "options", $$v)
                    },
                    expression: "normativeGroup.options"
                  }
                }),
                errors[0]
                  ? _c("error", {
                      staticClass: "mt-3",
                      attrs: {
                        message: "Seleccione al menos un grupo",
                        variant: "no-border"
                      }
                    })
                  : _vm._e()
              ]
            }
          }
        ])
      }),
      !_vm.isReadOnly
        ? _c(
            "div",
            { staticClass: "my-3" },
            [
              _c(
                "div",
                { staticClass: "col d-flex align-items-end" },
                [
                  _c("custom-drop-down", {
                    staticClass: "w-40",
                    attrs: {
                      clearable: false,
                      fieldkey: "id",
                      fieldname: "name",
                      "is-html": "",
                      label: "Prueba/Muestra - Módulo:",
                      options: _vm.modules,
                      placeholder: "Seleccione"
                    },
                    model: {
                      value: _vm.moduleSelected,
                      callback: function($$v) {
                        _vm.moduleSelected = $$v
                      },
                      expression: "moduleSelected"
                    }
                  }),
                  _c(
                    "action-button",
                    {
                      staticClass: "ml-2",
                      attrs: {
                        disabled: !_vm.moduleSelected,
                        i: "fas fa-file-plus",
                        variant: "success"
                      },
                      on: {
                        click: function($event) {
                          return _vm.addModule()
                        }
                      }
                    },
                    [_vm._v(" Añadir ")]
                  )
                ],
                1
              ),
              _c("validation-provider", {
                ref: "modules",
                attrs: {
                  name: "modules",
                  rules: _vm.answers.length > 0 ? "" : "required"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          errors[0]
                            ? _c("error", {
                                staticClass: "m-3",
                                attrs: {
                                  message: "Añada al menos un módulo",
                                  variant: "no-border"
                                }
                              })
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  649972377
                )
              })
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "m-3" }, [
        _vm.answers?.length
          ? _c(
              "div",
              { staticClass: "d-flex justify-content-end align-items-center" },
              [
                _c("action-button", {
                  staticClass: "outline-dark-gray",
                  attrs: {
                    i: _vm.allExpanded
                      ? "fal fa-compress-alt"
                      : "fal fa-expand-alt",
                    text: _vm.allExpanded ? "Colapsar Todo" : "Expandir Todo"
                  },
                  on: { click: _vm.toggleExpand }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "mx-3" },
          [
            _c(
              "custom-collapse",
              { attrs: { id: "answers-collapse" } },
              _vm._l(_vm.answers, function(item) {
                return _c(
                  "custom-collapse-item",
                  {
                    key: `answer-item-${item.id}`,
                    ref: `answer-item-${item.id}`,
                    refInFor: true,
                    staticClass: "my-3 collapse-item section bg-gray",
                    class: {
                      "rounded invalid": _vm.getAnswerForm(item)?.invalid
                    },
                    attrs: {
                      id: `answer-item-${item.id}`,
                      "auto-expand-collapse-enabled": false,
                      "button-icon": "far fa-times-circle color-red",
                      disabled: _vm.isReadOnly,
                      expanded: item.expanded,
                      "expanded-icon":
                        "fas fa-plus-circle custom-reorganize-btn",
                      "icon-class-when-button-disabled":
                        "fas fa-grip-vertical flex-fill d-flex justify-content-end align-items-center",
                      "keep-btn-visible": false,
                      "parent-id": "answers-collapse",
                      "read-only-icon": "fas fa-plus-circle color-gray-2",
                      title: _vm.getAnswerTitle(item)
                    },
                    on: {
                      actionButtonClick: function($event) {
                        return _vm.quit(item)
                      },
                      expandButtonClick: function($event) {
                        return _vm.expand(item)
                      }
                    }
                  },
                  [
                    _c("answer", {
                      ref: `answer-form-${item.id}`,
                      refInFor: true,
                      attrs: { "is-read-only": _vm.isReadOnly, value: item },
                      on: {
                        input: function($event) {
                          return _vm.onAnswer(item, $event)
                        }
                      }
                    })
                  ],
                  1
                )
              }),
              1
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "m-3" },
        [
          _c("label", { staticClass: "font-weight-bold" }, [
            _vm._v(" Interpretación de las pruebas VALPAR administradas: ")
          ]),
          _vm.isReadOnly
            ? _c("p", [_vm._v(_vm._s(_vm._f("empty")(_vm.model.comment)))])
            : _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-text-area", {
                          attrs: {
                            "count-classes": [
                              "d-block",
                              "small-counter",
                              "text-right"
                            ],
                            "custom-error-msg": "El campo es requerido.",
                            error: errors[0],
                            maxlength: 5000,
                            "show-char-count": ""
                          },
                          model: {
                            value: _vm.model.comment,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "comment", $$v)
                            },
                            expression: "model.comment"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }